<template>
  <div class="div-block-102 grid">
    <div class="div-block-147">
      <div class="overlfowXauto MGbottom20px">
        <div class="mortgage-result-broker signed">
          <div class="mortgage-parameters signed">
            <img
              :src="application.bank.logo_square"
              loading="lazy"
              alt=""
              class="bank-logo"
            >
            <div
              class="bold wrap100px"
            >
            <span class="light">suma</span><br>{{ getTotalAmountBasedOnCorrection() | dotTheAmount }} EUR
            </div>
            <div
              class="bold wrap50px"
            ><span class="light">sadzba</span><br>
              {{ application.sadzba_schvalena | toFloor(2) }}<span class="upper-index">%</span>
            </div>
            <div
              class="bold wrap100px"
            ><span class="light">splátka</span><br>{{ application.splatka | dotTheAmount }} <span class="upper-index">EUR</span>
            </div>
            <div
              class="bold wrap50px"
            > <span class="light">poplatok</span><br>{{  application.poplatok_za_poskytnutie | dotTheAmount }} <span class="upper-index">EUR</span>
            </div>
            <div class="bold wrap50px"><span class="light">splatnosť</span><br>{{ application.splatnost }}
              <span
                class="upper-index">R</span></div>
            <div class="bold wrap50px">FIX {{ application.fix }}</div>
          </div>
        </div>
      </div>


      <div class="div-block-148 topalign">
        <div class="div-block-110 primary">1</div>
        <div>Nahrajte úverovú dokumentáciu</div>
      </div>


      <div class="div-block-153 upload-grid upload-grid--contracts">
        <document-cloud-handler
          v-for="(missingFile, index) in cloudGetter.missingFiles"
          v-if="firstStepFiles.includes(missingFile.code)"
          :key="index + 'cldmis'"
          :title="getRequiredFileLabel(missingFile)"
          :type="missingFile.id"
          :uploaded="missingFile.uploaded"
          :class-cst="'upload-item-broker-custom'"
          :cloud-meta="cloudGetter.cloudMeta"
          :rules="['priority']"
          :show-files="false"
          text-button
          leading-text
        />
      </div>
      <div
        v-if="firstStepPickedFilesGetter.length"
        class="uploaded-document-list"
        aria-label="Nahraná úverová dokumentácia"
      >
        <div
          v-for="(file, index) in firstStepPickedFilesGetter"
          :key="file.id || `first-step-file-${index}`"
          class="uploaded-document-row"
        >
          <div class="uploaded-document-status" aria-hidden="true">✓</div>
          <div class="uploaded-document-copy">
            <div class="uploaded-document-type">{{ getFileTypeLabel(file) }}</div>
            <div class="small fileName">{{ file.name }}</div>
          </div>
          <div class="uploaded-document-badge">nahrané</div>
        </div>
      </div>

      <section
        v-if="clientNeedsRecordMissingFile && mortgageCloudGetter"
        class="client-needs-record-section"
      >
        <div class="client-needs-record-heading">
          <span class="client-needs-record-icon" aria-hidden="true">
            <app-icon name="clipboard" :size="22" />
          </span>
          <div>
            <div class="client-needs-record-title">Záznam o sprostredkovaní</div>
            <div class="client-needs-record-description">
              Podpísaný záznam o potrebách klienta sa uloží do cloudu celej hypotéky.
            </div>
          </div>
        </div>
        <div class="client-needs-record-upload">
          <document-cloud-handler
            :title="getRequiredFileLabel(clientNeedsRecordMissingFile)"
            :type="clientNeedsRecordMissingFile.id"
            :uploaded="clientNeedsRecordMissingFile.uploaded"
            :class-cst="'upload-item-broker-custom upload-item-broker-custom--record'"
            :cloud-meta="mortgageCloudGetter.cloudMeta"
            :rules="['priority']"
            :show-files="false"
            text-button
            leading-text="nahrať záznam"
          />
        </div>
        <div
          v-if="clientNeedsRecordPickedFilesGetter.length"
          class="uploaded-document-list uploaded-document-list--record"
          aria-label="Nahraný záznam o sprostredkovaní"
        >
          <div
            v-for="(file, index) in clientNeedsRecordPickedFilesGetter"
            :key="file.id || `client-needs-record-${index}`"
            class="uploaded-document-row"
          >
            <div class="uploaded-document-status" aria-hidden="true">✓</div>
            <div class="uploaded-document-copy">
              <div class="uploaded-document-type">Záznam o sprostredkovaní</div>
              <div class="small fileName">{{ file.name }}</div>
            </div>
            <div class="uploaded-document-badge">nahrané</div>
          </div>
        </div>
      </section>

      <div class="div-block-148 topalign MGtop20px">
        <div class="div-block-110 primary">2</div>
        <div>Vyberte model čerpania</div>
      </div>
      <div class="div-block-148">
        <div class="dropdown-input-custom contrast rest-input">
          <dropdown-select
            @select="setDropdownValue($event)"
            :id="'credit_card_banka'"
            :init-value="mortgage.cerpanie_na_zapis_zalozneho_prava"
            :options="secondStepChoices"
            normal
          />
        </div>
      </div>
    </div>
    <div class="div-block-147 MGtop20px">
        <div class="div-block-148 topalign">
          <div class="div-block-110 primary">3</div>
          <div>Nahrajte podklady pre čerpanie</div>
        </div>
        <div class="div-block-153 upload-grid">
          <document-cloud-handler
            v-for="(missingFile, index) in cloudGetter.missingFiles"
            v-if="thirdStepFiles.includes(missingFile.code)"
            :key="index + 'cldmis'"
            :title="missingFile.name"
            :type="missingFile.id"
            :uploaded="missingFile.uploaded"
            :class-cst="'upload-item-broker-custom'"
            :cloud-meta="cloudGetter.cloudMeta"
            :rules="['priority']"
            :show-files="false"
            text-button
            leading-text
          />
        </div>
        <div
          v-if="thirdStepPickedFilesGetter.length"
          class="uploaded-document-list"
          aria-label="Nahrané podklady pre čerpanie"
        >
            <div
              v-for="(file, index) in thirdStepPickedFilesGetter"
              :key="file.id || `third-step-file-${index}`"
              class="uploaded-document-row"
            >
              <div class="uploaded-document-status" aria-hidden="true">✓</div>
              <div class="uploaded-document-copy">
                <div class="uploaded-document-type">{{ getFileTypeLabel(file) }}</div>
                <div class="small fileName">{{ file.name }}</div>
              </div>
              <div class="uploaded-document-badge">nahrané</div>
            </div>
        </div>
        <div class="div-block-153 MGtop20px">
          <v-progress-circular
            v-if="zipDownloading"
            class="loading-spinner extrasmall"
            indeterminate
          ></v-progress-circular>
          <button type="button" class="download-all-button" v-else @click="download">
            <span class="download-all-icon" aria-hidden="true">
              <app-icon name="download" :size="19" />
            </span>
            <span>Stiahnuť všetky podklady</span>
          </button>
        </div>
        <div class="div-block-148 topalign MGtop20px">
          <div class="div-block-110 primary">4</div>
          <div>Hypotéka bola načerpaná dňa</div>
        </div>
        <div class="div-block-153">
          <div class="input-group drawdown-date-row">
            <input
              v-model="form.nacerpana"
              name="dateOfBirth"
              type="date"
              class="text-input w-input date-input contrast"
              maxlength="256"
            />
            <select
              v-model.number="form.paymentDay"
              class="text-input w-input drawdown-payment-day contrast"
              aria-label="Deň mesačnej splátky"
              required
            >
              <option :value="null" disabled>Deň splátky</option>
              <option v-for="day in paymentDays" :key="day" :value="day">
                Splátka {{ day }}. deň
              </option>
            </select>
            <button
              class="drawdown-confirm-button"
              :disabled="!canSubmitDrawdown || drawdownSaving"
              @click="confirmDrawMortgage"
            >
              <span v-if="drawdownSaving">ukladám...</span>
              <span v-else>{{ mortgage && mortgage.nacerpana ? "Uložiť dátum" : "Potvrdiť načerpanie" }}</span>
            </button>
          </div>
        </div>
    </div>
    <div class="text-small light MGtop20px">V prípade tohto kroku <b>nie je potrebné nahrať skeny</b> všetkych podkladov na čerpanie, táto funkcia slúži skôr ako manuál k čerpaniu s možnosťou uchovať si úverovú zmluvu a ostatné dokumenty v archíve pre prípad do budúcna.</div>
    <div v-if="showDrawdownSuccess" class="drawdown-success-overlay">
      <div class="drawdown-confetti" aria-hidden="true">
        <span v-for="index in 18" :key="index" :style="confettiStyle(index)"></span>
      </div>
      <div class="drawdown-success-card">
        <div class="drawdown-success-badge">✓</div>
        <div class="drawdown-success-title">Hypotéka načerpaná</div>
        <div class="drawdown-success-text">
          Obchod je úspešne dokončený a hypotéka bola presunutá do servisu.
        </div>
        <button class="drawdown-success-button" @click="showDrawdownSuccess = false">
          Hotovo
        </button>
      </div>
    </div>
</div>
</template>

<script>
import DocumentCloudHandler from "@/components/shared/PopupHandler/Popups/DocumentCloud/DocumentCloudHandler.vue";
import DropdownSelect from "@/components/shared/DropdownSelect.vue";
import AppIcon from "@/components/shared/AppIcon.vue";
import {mapGetters} from "vuex";
import cloudsHelpers from "@/mixins/cloudsHelpers";
import {patchClientDebt} from "@/services/brokerService";


export default {
  name: "ApplicationDocumentFinish",
  components: {AppIcon, DropdownSelect, DocumentCloudHandler},
  mixins: [
    cloudsHelpers,
  ],

  created() {
    this.mortgage = this.$store.getters["mortgageDetailState/getMortgage"];
    this.form.nacerpana = this.mortgage.nacerpana;
    let application = (this.$store.getters["mortgageDetailState/getApplicationByStage"]("cerpana"))[0];
    if (!application) application = (this.$store.getters["mortgageDetailState/getApplicationByStage"]("nacerpana"))[0];
    this.application = application;
    this.form.paymentDay = application?.preferred_payment_day || this.mortgage.preferred_payment_day || null;
  },
  computed: {
    ...mapGetters({
      mortgageGetter: "mortgageDetailState/getMortgage"
    }),
    canSubmitDrawdown() {
      const paymentDayChanged = Number(this.form.paymentDay) !== Number(
        this.application?.preferred_payment_day || this.mortgage?.preferred_payment_day || 0
      );
      return Boolean(this.form.nacerpana && this.form.paymentDay) && (
        !this.mortgage ||
        this.form.nacerpana !== this.mortgage.nacerpana ||
        paymentDayChanged
      );
    },
    cloudGetter() {
      if (!this.application) return [];
      return this.$store.getters["mortgageDetailCloud/getCloudByCloudId"](this.application.cloud);
    },
    mortgageCloudGetter() {
      if (!this.mortgage?.cloud) return null;
      return this.$store.getters["mortgageDetailCloud/getCloudByCloudId"](this.mortgage.cloud);
    },
    clientNeedsRecordMissingFile() {
      return this.mortgageCloudGetter?.missingFiles?.find(
        (file) => file.code === this.clientNeedsRecordCode
      ) || null;
    },
    clientNeedsRecordPickedFilesGetter() {
      if (!this.mortgage?.cloud) return [];
      const files = this.$store.getters["mortgageDetailCloud/getPickedCloudFilesByCloudId"](
        this.mortgage.cloud
      ) || [];
      return files.filter((file) => file.type?.code === this.clientNeedsRecordCode);
    },
    firstStepPickedFilesGetter() {
      if (!this.application) return [];
      const files = this.$store.getters["mortgageDetailCloud/getPickedCloudFilesByCloudId"](this.application.cloud) || [];
      return files.filter((file) => this.firstStepFiles.includes(file.type?.code));
    },
    thirdStepPickedFilesGetter() {
      if (!this.application) return [];
      const files = this.$store.getters["mortgageDetailCloud/getPickedCloudFilesByCloudId"](this.application.cloud) || [];
      return files.filter((file) => this.thirdStepFiles.includes(file.type?.code));
    }
  },
  watch: {
    mortgageGetter(newMortgage) {
      this.mortgage = newMortgage;
    },
  },
  methods: {
    async confirmDrawMortgage() {
      if (!this.form.nacerpana || !this.form.paymentDay) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Najprv zadajte dátum načerpania aj deň mesačnej splátky",
          type: "error"
        });
        return;
      }
      this.showConfirmationDialog();
      const userConfirmation = await this.askForUserPermission();
      if (!userConfirmation) {
        this.form.nacerpana = this.mortgage.nacerpana;
        return;
      }
      await this.saveDrawMortgage(this.form.nacerpana);
    },
    async saveDrawMortgage(date) {
      this.drawdownSaving = true;
      try {
        const isFirstDrawdown = !this.mortgage.nacerpana;
        await this.patchMortgage(date);
        if (isFirstDrawdown) {
          await this.createDebtFromDrawedMortgage();
        } else {
          await this.updateDrawnMortgageDebt();
        }
        this.showDrawdownSuccess = true;
        this.$store.commit("appState/setSuccessMessage", {
          text: "Hypotéka bola úspešne označená ako načerpaná",
          type: "success"
        });
      } finally {
        this.drawdownSaving = false;
      }
    },
    async patchMortgage(date) {
      const mortgageObject = {
        id: this.mortgage.id,
        object: {
          nacerpana: date,
          preferred_payment_day: this.form.paymentDay,
        }
      }
      if (!this.mortgage.nacerpana) {
        mortgageObject.object.stage = "servis";
        mortgageObject.object.stage_old = this.mortgage.stage;
        await this.patchApplicationStage();
      }
      await this.patchApplicationPaymentDay();
      await this.$store.dispatch("mortgageDetailState/patchMortgage", mortgageObject);
    },
    async createDebtFromDrawedMortgage() {
      const client = this.$store.getters["mortgageDetailState/getApplicant"];
      const clientInfo = {
        type: "Žiadateľ",
        type_code: "applicant",
        id: client.id,
        firstName: client.first_name,
        lastName: client.last_name
      }
      const total = this.totalAmounts(this.application);
      const data = {
        clientLabel: clientInfo.type,
        clientRole: clientInfo.type_code,
        object: {
          clientInfo: clientInfo,
          klient: clientInfo.id,
          sadzba: this.application.sadzba_schvalena,
          splatnost: this.calculateEndDate(this.application.splatnost, this.form.nacerpana),
          zaciatok: this.form.nacerpana,
          den_splatky: this.form.paymentDay,
          vyska_splatky: this.application.splatka,
          povodna_suma: total,
          zostatok: total,
          is_active: true,
          is_visible: true,
          fixacia: this.application.fix,
          banka: this.application.bank.id,
          typ: "hypoteka",
          zo_ziadosti: this.application.id,
          // limit:
          // den_splatky	Deň splátky v mesiaci[...]
        }
      }
      // console.log(data);
      await this.$store.dispatch("mortgageDetailState/createClientDebt", data);
    },
    async updateDrawnMortgageDebt() {
      const debt = this.application?.vytvoreny_debt;
      const debtId = typeof debt === "object" ? debt?.id : debt;
      if (!debtId) return;
      await patchClientDebt({
        zaciatok: this.form.nacerpana,
        splatnost: this.calculateEndDate(this.application.splatnost, this.form.nacerpana),
        den_splatky: this.form.paymentDay,
      }, debtId);
    },
    totalAmounts(application) {
      return application.suma_bezucel + application.suma_refinancovanie + application.suma_nadobudnutie;
    },
    calculateEndDate(years, startDate) {
      const [year, month, day] = String(startDate).split("-").map(Number);
      const endYear = year + Number(years || 0);
      const lastDay = new Date(Date.UTC(endYear, month, 0)).getUTCDate();
      return [
        endYear,
        String(month).padStart(2, "0"),
        String(Math.min(day, lastDay)).padStart(2, "0"),
      ].join("-");
    },
    async patchApplicationStage() {
      const applicationObject = {
        id: this.application.id,
        newStage: "nacerpana",
      }
      await this.$store.dispatch("mortgageDetailState/setMortgageApplicationStage", {...applicationObject});
    },
    async patchApplicationPaymentDay() {
      await this.$store.dispatch("mortgageDetailState/patchMortgageApplication", {
        id: this.application.id,
        applicationPatchData: {
          preferred_payment_day: this.form.paymentDay,
        },
      });
      this.application.preferred_payment_day = this.form.paymentDay;
    },
    showConfirmationDialog () {
      const date = this.formatDateForMessage(this.form.nacerpana);
      this.$store.commit("appState/setSuccessMessage", {
        text: `Potvrdiť načerpanie hypotéky k dátumu ${date}?`,
        type: "confirmation"
      });
    },
    formatDateForMessage(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    askForUserPermission () {
      return new Promise((resolve) => {
        const int = setInterval(() => {
          const userConfirmation = this.$store.getters["appState/getUserConfirmation"];
          if (userConfirmation === true) {
            this.$store.commit("appState/setUserConfirmation", null);
            clearInterval(int);
            resolve(true);
          } else if (userConfirmation === false) {
            this.$store.commit("appState/setUserConfirmation", null);
            clearInterval(int);
            resolve(false);
          }
        }, 100);
      });
    },
    getTotalAmountBasedOnCorrection() {
      if (this.application.stage === 'rozpracovana') {
        if (this.application.backEndLimitCorrected) {
          return this.application.correctedAmount;
        }
      }
      return (
          this.application.suma_nadobudnutie +
          this.application.suma_refinancovanie +
          this.application.suma_bezucel
      );
    },
    async download() {
      this.zipDownloading = true;
      try {
        const applicantSurname = (this.$store.getters["mortgageDetailState/getApplicant"]).last_name;
        await this.downloadFilesAsZip(this.thirdStepPickedFilesGetter, `${applicantSurname}_cerpanie`);
      } finally {
        this.zipDownloading = false;
      }
    },
    getFileTypeLabel(file) {
      const code = file.type?.code;
      const missingFile = this.cloudGetter?.missingFiles?.find((item) => item.code === code);
      return this.getRequiredFileLabel(missingFile || file.type);
    },
    getRequiredFileLabel(fileType) {
      if (fileType?.code === "podpisany_zaznam_o_potrebach_klienta") {
        return "Záznam o sprostredkovaní / potrebách klienta";
      }
      return fileType?.name || "Dokument";
    },
    setDropdownValue(value) {
      const mortgageObject = {
        id: this.mortgage.id,
        object: {
          cerpanie_na_zapis_zalozneho_prava: value
        }
      }
      // console.log(mortgageObject);
      this.$store.dispatch("mortgageDetailState/patchMortgage", mortgageObject);
    },
    confettiStyle(index) {
      const left = (index * 23) % 100;
      const delay = (index % 6) * 0.08;
      const duration = 1.9 + (index % 5) * 0.18;
      const colors = ["#2a8bf2", "#0019d9", "#20a134", "#ffd166", "#ff5c8a"];
      return {
        left: `${left}%`,
        background: colors[index % colors.length],
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
      };
    }
  },
  data: () => ({
    mortgage: null,
    application: null,
    zipDownloading: false,
    drawdownSaving: false,
    showDrawdownSuccess: false,
    form: {
      nacerpana: null,
      paymentDay: null,
    },
    paymentDays: [5, 10, 15, 20, 25],
    todayLong: new Date().toISOString().substr(0, 10),
    firstStepFiles: [
      "uverova_zmluva",
      "zalozna_zmluva",
    ],
    clientNeedsRecordCode: "podpisany_zaznam_o_potrebach_klienta",
    secondStepChoices: [
      {
        display_name: "štandardné na plombu",
        value: false,
      },
      {
        display_name: "na zápis záložného práva",
        value: true,
      },
    ],
    thirdStepFiles: ["podpisana_uverova_zmluva","podpisana_zalozna_zmluva","potvrdeny_navrh_na_vklad_zalozneho_prava","doklad_o_uhrade_rozdielu_kupnej_ceny_a_hypo","podpisana_kupna_zmluva","vycislenie_zostatku_hypo","vinkulacia_poistnej_sumy_v_prospech_novej_banky"],
  }),
}
</script>

<style scoped>
.div-block-102.grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.div-block-147 {
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background-color: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
}

.div-block-147.MGtop20px {
  margin-top: 0;
}

.mortgage-result-broker.signed {
  min-width: 760px;
  margin: 0;
  padding: 16px 18px;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
  box-shadow: none;
}

.mortgage-parameters.signed {
  color: var(--app-text);
}

.mortgage-parameters .light,
.upper-index {
  color: var(--app-text-muted);
}

.div-block-148.topalign {
  display: flex;
  margin: 18px 0 10px;
  padding: 0;
  align-items: center;
  gap: 10px;
  color: var(--app-text);
  font-weight: 700;
}

.div-block-148.topalign .div-block-110 {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 1px solid var(--app-primary);
  background: var(--app-primary-soft);
  color: var(--app-primary);
  font-size: 11px;
}

.div-block-153 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  gap: 10px;
}

.upload-grid--contracts {
  grid-template-columns: repeat(2, minmax(180px, 240px));
}

.div-block-153 .upload-item-broker-custom {
  box-sizing: border-box;
  min-height: 108px;
  margin: 0;
  padding: 16px;
  border-width: 1px;
  border-color: color-mix(in srgb, var(--app-primary) 42%, var(--app-border));
  border-radius: 14px;
  background: color-mix(in srgb, var(--app-primary-soft) 58%, var(--app-surface));
  color: var(--app-text);
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.div-block-153 .upload-item-broker-custom:hover,
.client-needs-record-upload .upload-item-broker-custom:hover {
  border-color: var(--app-primary);
  background: color-mix(in srgb, var(--app-primary-soft) 82%, var(--app-surface));
  transform: translateY(-1px);
}

::v-deep .upload-item-broker-custom .link-icon-text {
  gap: 1px;
  color: var(--app-primary) !important;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.3;
}

::v-deep .upload-item-broker-custom > div:last-child {
  margin-top: 5px;
  color: var(--app-text);
  font-size: 11px;
  font-weight: 800;
  line-height: 1.35;
}

.client-needs-record-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 420px);
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid color-mix(in srgb, var(--app-primary) 26%, var(--app-border));
  border-radius: 14px;
  background: var(--app-surface-muted);
}

.client-needs-record-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.client-needs-record-icon {
  display: flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: var(--app-primary-soft);
  color: var(--app-primary);
}

.client-needs-record-title {
  color: var(--app-text);
  font-size: 13px;
  font-weight: 900;
}

.client-needs-record-description {
  max-width: 520px;
  margin-top: 4px;
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 600;
  line-height: 1.45;
}

.client-needs-record-upload {
  min-width: 0;
}

.client-needs-record-upload .upload-item-broker-custom {
  box-sizing: border-box;
  width: 100%;
  min-height: 92px;
  margin: 0;
  padding: 14px;
  border-width: 1px;
  border-color: color-mix(in srgb, var(--app-primary) 42%, var(--app-border));
  border-radius: 14px;
  background: color-mix(in srgb, var(--app-primary-soft) 58%, var(--app-surface));
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.uploaded-document-list--record {
  grid-column: 1 / -1;
  width: 100%;
  margin-top: 0;
}

.download-all-button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 9px;
  padding: 0 14px;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
}

.download-all-button:hover {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
}

.download-all-icon {
  display: inline-flex;
}

.uploaded-document-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  width: min(760px, 100%);
  margin-top: 12px;
}

.uploaded-document-row {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid color-mix(in srgb, var(--app-primary) 30%, var(--app-border));
  border-radius: 12px;
  background: color-mix(in srgb, var(--app-primary-soft) 68%, var(--app-surface));
}

.uploaded-document-status {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--app-primary);
  color: #fff;
  font-size: 15px;
  font-weight: 900;
}

.uploaded-document-copy {
  min-width: 0;
}

.uploaded-document-type {
  margin-bottom: 2px;
  color: var(--app-text);
  font-size: 11px;
  font-weight: 800;
}

.uploaded-document-copy .fileName {
  overflow: hidden;
  color: var(--app-text-muted);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uploaded-document-badge {
  padding: 4px 7px;
  border-radius: 999px;
  background: color-mix(in srgb, #20a134 14%, transparent);
  color: #168137;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.rest-input {
  width: min(360px, 100%);
  border: 1px solid var(--app-border);
  background: var(--app-surface-muted);
  color: var(--app-text);
}

.rest-input * {
  color: var(--app-text) !important;
}

.link-block-7 {
  justify-content: space-around;
  gap: 10px;
}

.overlfowXauto{
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  padding: 0;
}

.drawdown-date-row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.drawdown-confirm-button {
  min-height: 46px;
  padding: 0 20px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(90deg, #2a8bf2 0%, #0019d9 100%);
  color: #fff;
  font-weight: 800;
  box-shadow: 0 16px 32px rgba(42, 139, 242, 0.18);
  transition: transform 0.18s ease, opacity 0.18s ease, box-shadow 0.18s ease;
}

.drawdown-payment-day {
  width: auto;
  min-width: 165px;
}

.drawdown-confirm-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 36px rgba(42, 139, 242, 0.24);
}

.drawdown-confirm-button:disabled {
  opacity: 0.42;
  cursor: not-allowed;
  box-shadow: none;
}

.drawdown-success-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(8, 18, 48, 0.36);
  backdrop-filter: blur(4px);
}

.drawdown-success-card {
  position: relative;
  z-index: 1;
  width: min(430px, 100%);
  padding: 34px 30px 28px;
  border-radius: 18px;
  border: 1px solid var(--app-border);
  background: var(--app-surface);
  text-align: center;
  box-shadow: 0 30px 80px rgba(0, 22, 80, 0.24);
}

.drawdown-success-badge {
  width: 72px;
  height: 72px;
  margin: 0 auto 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2a8bf2 0%, #0019d9 100%);
  color: #fff;
  font-size: 40px;
  font-weight: 900;
  box-shadow: 0 16px 36px rgba(42, 139, 242, 0.28);
}

.drawdown-success-title {
  color: var(--app-text);
  font-size: 28px;
  font-weight: 900;
  line-height: 1.12;
}

.drawdown-success-text {
  max-width: 330px;
  margin: 12px auto 24px;
  color: var(--app-text-muted);
  font-weight: 700;
  line-height: 1.45;
}

.drawdown-success-button {
  min-width: 140px;
  height: 48px;
  border: 0;
  border-radius: 12px;
  background: var(--app-primary);
  color: #fff;
  font-weight: 800;
}

.drawdown-confetti {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.drawdown-confetti span {
  position: absolute;
  top: -20px;
  width: 10px;
  height: 18px;
  border-radius: 3px;
  animation-name: drawdown-confetti-fall;
  animation-timing-function: cubic-bezier(0.18, 0.72, 0.32, 1);
  animation-fill-mode: forwards;
}

@keyframes drawdown-confetti-fall {
  0% {
    opacity: 0;
    transform: translate3d(0, -20px, 0) rotate(0deg);
  }
  10% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate3d(34px, 100vh, 0) rotate(520deg);
  }
}

@media (max-width: 991px) {
  .div-block-153 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .upload-grid--contracts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .client-needs-record-section {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 767px) {
  .div-block-153 {
    grid-template-columns: minmax(0, 1fr);
  }

  .uploaded-document-list {
    grid-template-columns: minmax(0, 1fr);
  }

  .uploaded-document-row {
    grid-template-columns: 32px minmax(0, 1fr);
  }

  .uploaded-document-badge {
    grid-column: 2;
    justify-self: start;
  }

  .drawdown-date-row {
    align-items: stretch;
  }

  .drawdown-date-row .date-input,
  .drawdown-payment-day,
  .drawdown-confirm-button {
    width: 100%;
  }

  .drawdown-success-title {
    font-size: 24px;
  }
}

</style>
